'use client';

import TruncatedText from '~/components/TruncatedText';
import { cn } from '~/lib/utils';

type QuoteProps = {
  text: React.ReactNode;
  /** Full text for the overflow tooltip. Defaults to `text` when that is a string. */
  title?: string;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>;

export default function Quote({ text, className, title, ...others }: QuoteProps) {
  return (
    <TruncatedText
      as="div"
      tooltip={title ?? (typeof text === 'string' ? text : undefined)}
      className={cn(
        'bg-muted/60 text-foreground/90 rounded-md px-2.5 py-2 text-sm leading-relaxed',
        className,
      )}
      {...others}
    >
      {text}
    </TruncatedText>
  );
}
